/**
 * Created by methee on 8/30/17.
 */

import React from 'react';
import gql from 'graphql-tag';

import Layout from '../../components/Layout';
import Blog from './Blog';

async function action({ client }, { slug }) {
  const getBlogPost = async () => {
    const blogPostQuery = gql`
      query Blog {
      getBlogPost(slug: "${slug || ''}") {
        id
        category
        date
        title
        feature_image
        content
        slug
      }
    }`;
    const { data, errors } = await client.networkInterface.query({
      query: blogPostQuery,
    });
    if (errors) {
      console.error(errors);
    }
    return data.getBlogPost;
  };
  const data = await getBlogPost();
  return {
    chunks: ['blog-post'],
    title: data ? data.title : '',
    metaOGUrl: data ? `https://www.redplanethotels.com/blog/post/${slug}` : '',
    metaOGType: data ? 'article' : '',
    metaOGTitle: data ? data.title : '',
    metaOGDesc: data ? data.title : '',
    metaOGImage: data ? data.feature_image : '',
    component: (
      <Layout>
        <Blog post={data} />
      </Layout>
    ),
  };
}

export default action;
